// modules
import React from "react";
import { Redirect, Route } from "react-router-dom";

export const ProtectedRoute = ({ component: Component, isAuthenticated, condition, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => (isAuthenticated === true && condition ? <Component {...props} /> : <Redirect to="/" />)}
        />
    );
};
